module.exports = __webpack_public_path__ + "img/pants side seam length.96c42f37.png";